import { useTranslation } from 'react-i18next';
import { S } from '../regureStyles';
import PageSizeSelector from '../../components/PageSizeSelector';

const Pagination = ({ totalPages, setPage, page, paginated, filtered, pageSize, setPageSize }) => {
  const { t } = useTranslation();
  return (
    <div
      style={{
        padding: '14px 32px',
        borderTop: `1px solid ${S.borderLight}`,
        background: 'rgba(255,255,255,0.8)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 16,
      }}
    >
      <span style={{ fontSize: 13, color: S.textMuted }}>
        {t('screens.policiesScreen.showingOf', { shown: paginated.length, total: filtered.length })}
      </span>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        {typeof pageSize === 'number' && setPageSize && (
          <PageSizeSelector pageSize={pageSize} setPageSize={setPageSize} />
        )}
        <div style={{ display: 'flex', gap: 4 }}>
        {Array.from({ length: totalPages }, (_, i) => i + 1).map(p => (
          <button
            key={p}
            onClick={e => {
              e.stopPropagation();
              setPage(p);
            }}
            style={{
              width: 32,
              height: 32,
              borderRadius: 8,
              border: p === page ? `1px solid ${S.burgundy}` : `1px solid ${S.borderLight}`,
              background: p === page ? 'rgba(128,0,32,0.07)' : '#fff',
              color: p === page ? S.burgundy : S.textSecondary,
              fontSize: 13,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            {p}
          </button>
        ))}
        </div>
      </div>
    </div>
  );
};

export default Pagination;
